import { Route, Routes } from 'react-router-dom'
import Section from 'app/frontend/base/components/Section'
import { useTeam } from 'app/frontend/base/config/context/team'
import NewsIndex from './components/NewsIndex'
import NewsForm from './components/NewsForm'
import NewsView from './components/NewsView'

const TeamNewsRoutes = () => {
  return (
    <Routes>
      <Route path='/' element={<NewsIndex />} />
      <Route path='/new' element={<NewsForm />} />
      <Route path='/:id' element={<NewsView />} />
      <Route path='/:id/edit' element={<NewsForm />} />
    </Routes>
  )
}

const TeamNews = () => {
  const { team, guild } = useTeam()

  return (
    <Section title={`News | ${team.name} | ${guild.name}`}>
      <TeamNewsRoutes />
    </Section>
  )
}

export default TeamNews
